<template>
  <div>
    <!-- <div class="row">
      <div class="col">
        <div class="card shadow"> -->
    <div class="row no-gutters">
      <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
        <div class="card-body">
          <div class="filter-bar ui basic segment grid">
            <div class="row">
              <div class="col-md-12">
                <base-input label="Business Date"><br>
                  <a-range-picker v-model="filterText.business_date" format="MM/DD/YYYY"
                    :placeholder="['Start Date', 'End Date']" style="width:100%" @change="doFilter" />
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <base-input label="Site"><br>
                  <a-select v-model="filterText.site_id" showSearch placeholder="Search by site"
                    @change="filterTerminal" optionFilterProp="children" style="width: 100%"
                    :filterOption="filterOption">
                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">
                      {{ option.name }}
                    </a-select-option>
                  </a-select>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <base-input label="Terminal"><br>
                  <a-select v-model="filterText.terminal_id" showSearch placeholder="Search by terminal"
                    @change="doFilter" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                    <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">
                      {{ option.name }}
                    </a-select-option>
                  </a-select>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <base-input label="Trans ID"><br>
                  <input v-model="filterText.trans_id" type="text" class="form-control" placeholder="Search trans ID"
                    @change="doFilter">
                </base-input>
              </div>
            </div>
            <div class="col-md-12">
              <base-input label="Status">
                <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
                  All
                </base-radio>
                <base-radio name="1" class="mb-3" v-model="filterStatus" value="1">
                  Posted
                </base-radio>
                <base-radio name="2" class="mb-3" v-model="filterStatus" value="2">
                  Suspended
                </base-radio>
                <base-radio name="3" class="mb-3" v-model="filterStatus" value="3">
                  Aborted
                </base-radio>
                <base-radio name="4" class="mb-3" v-model="filterStatus" value="4">
                  Voided
                </base-radio>
                <base-radio name="5" class="mb-3" v-model="filterStatus" value="5">
                  Sent to PDE
                </base-radio>
                <base-radio name="6" class="mb-3" v-model="filterStatus" value="6">
                  Not sent to PDE
                </base-radio>
              </base-input>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-9">
        <div id="profileDiv" class="card-body">
          <profiles-table :filterText="filterText" :key="formKey"></profiles-table>
        </div>
      </div>
    </div>
  </div>
  <!-- </div>
    </div>
  </div> -->
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import ProfilesTable from '../Tables/SalesResenderTable.vue'
import { mapState, mapActions } from 'vuex'
import moment from 'moment';

var component_x;

export default {
  data: function () {
    return {
      formKey: 0,
      activeModules: [],
      filterSettings: {},
      filterText: {
        terminal_id: 0,
        site_id: 0,
        // business_date: [moment().subtract(2,'years'), moment().endOf('day')],
        business_date: [moment().startOf('day'), moment().endOf('day')], // 2960 [F&B] Set Business Date in filters default to current date
        trans_id: '',
        customer_name: '',
        filterStatus: '0',
        returnStatus: '0',
        reservationStatus: '0',
      },
      //   searchFilter: "terminal_id",
      filterStatus: '0',
      returnStatus: '0',
      reservationStatus: '0',
      dateFormat: "MM/DD/YYYY",
      terminalOptions: [],
      siteOptions: []
    }
  },
  mounted: async function () {
    component_x = this;

    var siteId = secureStorage.getItem("defaultSiteId")
    let userId = secureStorage.getItem("userId")

    var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
    component_x.siteOptions = sites;
    component_x.siteOptions.push({ id: 0, name: ' All Sites' })
    component_x.sort(component_x.siteOptions);
    component_x.filterText.site_id = siteId

    let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
    this.updateParameters("?customer_name=" + this.filterText.customer_name + "&site_id=" + siteId + "&from_date=" + this.filterText.business_date[0].format('YYYY-MM-DD') + "&to_date=" + this.filterText.business_date[1].format('YYYY-MM-DD'))

    component_x.terminalOptions = terminals;
    component_x.terminalOptions.push({ id: 0, name: ' All Terminals' })
    component_x.sort(component_x.terminalOptions);
  },
  computed: {
    ...mapState(['currentProfile', 'currentApiURL', 'endPoint']),
  },
  components: {
    ProfilesTable
  },
  watch: {
    filterStatus: async function () {
      Object.assign(this.filterText, {
        filterStatus: this.filterStatus
      })
      this.doFilter();
    },
    returnStatus: async function () {
      Object.assign(this.filterText, {
        returnStatus: this.returnStatus
      })
      this.doFilter();
    },
    reservationStatus: async function () {
      Object.assign(this.filterText, {
        reservationStatus: this.reservationStatus
      })
      this.doFilter();
    },
  },
  methods: {
    ...mapActions(['updateCurrentProfile', 'updateParameters']),
    moment,
    filterTerminal: async function () {
      component_x = this
      let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + component_x.filterText.site_id, null);
      component_x.terminalOptions = terminals;
      component_x.terminalOptions.push({ id: 0, name: ' All Terminals' })
      component_x.sort(component_x.terminalOptions);

      component_x.filterText.terminal_id = 0

      this.doFilter()
    },
    doFilter: async function () {
      let add_business_date = ""
      if (this.filterText.business_date != null && this.filterText.business_date.length != 0) {
        add_business_date = "&from_date=" + this.moment(this.filterText.business_date[0]).format('YYYY-MM-DD') + "&to_date=" + this.moment(this.filterText.business_date[1]).format('YYYY-MM-DD')
      }

      let add_terminal = ""
      if (this.filterText.terminal_id != 0) {
        add_terminal = "&terminal_id=" + this.filterText.terminal_id
      }

      let add_site = ""
      if (this.filterText.site_id != 0) {
        add_site = "&site_id=" + this.filterText.site_id
      }

      let add_status = ""
      // console.log("should be ", this.currentProfile)

      if (this.filterStatus == '0') {
        add_status = "&is_voided=" + this.filterStatus
      }
      if (this.filterStatus == '1') {
        add_status = "&status=" + 'P'
      }
      if (this.filterStatus == '2') {
        add_status = "&status=" + 'S'
      }
      if (this.filterStatus == '3') {
        add_status = "&status=" + 'A'
      }
      if (this.filterStatus == '4') {
        add_status = "&is_voided=" + "1"
      }
      if (this.filterStatus == '5') {
        add_status = "&pde_sent=" + "1"
      }
      if (this.filterStatus == '6') {
        add_status = "&pde_sent=" + "0"
      }


      let add_trans_id = ""
      if (this.filterText.trans_id != "") {
        add_trans_id = "&trans_id=" + this.filterText.trans_id
      }

      this.updateParameters("?customer_name=" + this.filterText.customer_name + add_trans_id + add_status + add_business_date + add_site + add_terminal)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    sort(data) {
      data.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
  }
};
</script>

<style></style>
